@if (loaderService.isLoading()) {
  <div class="container flex justify-content-center">
    <div class="flex flex-1 align-items-center w-full h-full">
      <p-progress-spinner
        class="spinner flex flex-1 align-items-center h-full"
        strokeWidth="5"
        fill="transparent"
        animationDuration=".8s"
      />
    </div>
  </div>
}
